import { useMutation } from '@tanstack/react-query'
import { useInvalidateQueries } from '../../../hooks/useInvalidateQueries'
import { removeOrders } from '../../../services/ApiService'
import { notifySuccess } from '../../../services/ToastifyService/ToastifyService'
import checkboxStore from '../../../stores/CheckboxStore'
import {
  closeModalFn,
  openModalFn,
} from '../../../utils/controllers/ModalController'
import { onError } from '../../SingleServiceReport/RequestReportActions/helpers'
import { REPORT_KEYS } from '../consts/request-report.keys'

export const useDeleteRequestFromReport = (reportId: number) => {
  const invalidate = useInvalidateQueries()
  const { mutateAsync: deleteRequestFn } = useMutation({
    mutationKey: ['delete-request-from-report'],
    mutationFn: (ids: number[]) => {
      const body = {
        orderIdList: ids,
        reportId: reportId,
      }
      return removeOrders(body)
    },
    onSuccess(_, variables) {
      closeModalFn['progress-backdrop']?.()
      checkboxStore.resetAll(true)
      const notification =
        variables.length > 1
          ? `Заявки №${variables.join(', ')} удалены из отчета  №${reportId}`
          : `Заявка №${variables.join(', ')} удалена из отчета  №${reportId}`
      notifySuccess(notification)

      invalidate([
        REPORT_KEYS.GET_REPORT_TABLE,
        REPORT_KEYS.GET_REPORT,
        REPORT_KEYS.GET_REPORTS,
        REPORT_KEYS.CREATE_REPORT,
        REPORT_KEYS.ADD,
      ])
    },
    onError,
  })

  const deleteRequest = (e: any, ids: number[]) => {
    e.stopPropagation()

    openModalFn['transaction-confirmation']?.({
      text1:
        ids.length > 1
          ? 'Подтвердить удаление заявок'
          : 'Подтвердить удаление заявки',
      value1: `№${ids.join(', ')}`,
      text2: 'из отчета',
      value2: `№${reportId}?`,
      action: () => deleteRequestFn(ids),
      processText:
        ids.length > 1
          ? `Выполняется удаление заявок №${ids.join(
              ', ',
            )} из отчета №${reportId}  `
          : `Выполняется удаление заявки №${ids.join(
              ', ',
            )} из отчета №${reportId}  `,
    })
  }

  return deleteRequest
}
